import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import EditDelivery from '../../shared/EditDelivery';

const DeliveryModal = ({ form, onConfirm, onHide, show, ...props }) => (
  <Modal onHide={onHide} show={show}>
    <Modal.Header>
      <Modal.Title>
        <FontAwesome name="pencil" /> Edit Delivery
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <EditDelivery {...props} purchaseOrder={form} />
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onHide}>Close</Button>
      <Button bsStyle="primary" onClick={onConfirm}>Save</Button>
    </Modal.Footer>
  </Modal>
);

export default DeliveryModal;
